import { render } from "./AppFooter.vue?vue&type=template&id=7a1c310f&scoped=true&ts=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=7a1c310f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1c310f"]])

export default __exports__